import { render } from "./what-batch-triggered.vue?vue&type=template&id=68aed702&lang=pug"
import script from "./what-batch-triggered.vue?vue&type=script&setup=true&lang=js"
export * from "./what-batch-triggered.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__